module.exports = __webpack_public_path__ + "img/69000.455ef9d6.jpg";